const ALLOWED_NAME_LENGTH = 40;

const ALLOWED_SEGMENT_TOPBAR_LENGTH = 30;

const GLOBAL_SEGMENT_NAME = 'global';

const PRIVATE_SEGMENT_NAME = 'private';

const TYPE_ID_PRIVATE = 1;

const TYPE_ID_GLOBAL = 2;

const DROPDOWN_PRIVATE_SEGMENT_TITLE = 'Private segments';

const DROPDOWN_GLOBAL_SEGMENT_TITLE = 'Organization segments';

const DEFAULT_SEGMENT_TYPE_ID = TYPE_ID_PRIVATE;


const SEGMENT_EDIT_MODE_CREATING = 'CREATING';

const SEGMENT_EDIT_MODE_EDITING_PROPERTIES = 'EDITING_PROPERTIES';

const SEGMENT_EDIT_MODE_EDITING_FILTERS = 'EDITING_FILTERS';

const DEFAULT_SEGMENT_EDIT_MODE = SEGMENT_EDIT_MODE_CREATING;

const SEGMENT_INVALID_NAME_ERROR_CODE = 599;

const BUTTON_SAVE_SEGMENT_LABEL = 'Save segment';

const BUTTON_UPDATE_SEGMENT_LABEL = 'Update segment';


export default {
  ALLOWED_NAME_LENGTH,
  ALLOWED_SEGMENT_TOPBAR_LENGTH,
  GLOBAL_SEGMENT_NAME,
  PRIVATE_SEGMENT_NAME,
  DEFAULT_SEGMENT_TYPE_ID,
  TYPE_ID_PRIVATE,
  TYPE_ID_GLOBAL,
  DROPDOWN_PRIVATE_SEGMENT_TITLE,
  DROPDOWN_GLOBAL_SEGMENT_TITLE,

  SEGMENT_EDIT_MODE_CREATING,
  SEGMENT_EDIT_MODE_EDITING_PROPERTIES,
  SEGMENT_EDIT_MODE_EDITING_FILTERS,
  DEFAULT_SEGMENT_EDIT_MODE,

  SEGMENT_INVALID_NAME_ERROR_CODE,

  BUTTON_SAVE_SEGMENT_LABEL,
  BUTTON_UPDATE_SEGMENT_LABEL
}